/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileWorkoutModel } from '../../models/profile-workout-model';

export interface ExternalWorkoutHistoryProfileIdGet$Params {

/**
 * The member profile identifier.
 */
  profileId: string;
}

export function externalWorkoutHistoryProfileIdGet(http: HttpClient, rootUrl: string, params: ExternalWorkoutHistoryProfileIdGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<Array<ProfileWorkoutModel>>> {
  const rb = new RequestBuilder(rootUrl, externalWorkoutHistoryProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<Array<ProfileWorkoutModel>>;
    })
  );
}

externalWorkoutHistoryProfileIdGet.PATH = '/External/WorkoutHistory/{profileId}';
